import React, { PureComponent } from "react";
import { withRouter } from 'react-router-dom'
import { Row, Col, Table, DatePicker, Card, Select, Tooltip } from 'antd'
import AppLayout from "../../../../components/layouts/AppLayout/index";
import ReportsService from "../../../../app/service/reportsService";
import { Button } from '../../../../components/button';
import { TableSearch } from "../../../../hooks";
import Moment from 'moment';
import { CSVLink } from "react-csv";
import moment from "moment";
import PlateService from "../../../../app/service/plateService";
import MgmtService from "../../../../app/service/mgmtService";

const TIME_FETCH_DATA = 60000;

class MgmtCommands extends PureComponent {

    /**
     *  Constructor
     */
    constructor(props) {
        super(props);
        this.reportsService = new ReportsService();
        this.tableSearch = new TableSearch();
        this.servicePlate = new PlateService();
        this.serviceMgmt = new MgmtService();
        this.state = {
            searchText: '',
            searchedColumn: '',
            loading: false,
            commandsData: [],
            tablePageSize: 10,
            totalRegisters: 0,
            endDate: Moment().add(1, 'days'),
            startDate: Moment().subtract(3, 'days'),
            currentPage: 1,
            plates: [],
        }
    }

    getPlates = () => {
        this.serviceMgmt
            .getPlates()
            .then(response => {
                let opt = [];
                response.data.data.forEach(item => {
                    opt.push({
                        value: item.plate,
                        label: item.plate
                    });
                });
                this.setState({
                    plates: opt,
                    loading: true,
                });

            })
            .catch(erros => {
                this.setState({
                    loading: false,
                });
                erros && erros.response && this.auth.verifyAuth(erros.response.status);
            })
    }

    interval = null;
    /**
     *  Call Backend and get all the commands according the specific date
     */
    filterCommands = (pageSize, pageIndex, startDate, endDate, plate) => {
        this.setState({
            loading: true,
        });
        const filter = {
            "pageSize": pageSize,
            "pageIndex": pageIndex,
            "startDate": startDate,
            "endDate": endDate,
            "plate": plate
        };
        this.serviceMgmt.getCommands(filter)
            .then(response => {
                if (response.data.status === 200) {
                    let options = [];
                    let commandsData = [];
                    response.data.data.map((value, index) => {
                        options.push({ key: index, value: value.plate });
                        commandsData.push({
                            key: index,
                            cmdType: value.cmdType + value.nameCmd,
                            loginId: value.loginId,
                            plate: value.plate,
                            plateId: value.plateId,
                            sentDate: value.sentDate,
                            slave: value.slave,
                            username: value.username,
                            responseDate: value.responseDate,
                            responseCmd: value.responseCmd,
                        });
                    });

                    this.setState({
                        loading: false,
                        commandsData: commandsData,
                        totalRegisters: response.data.totalRegisters,
                    });
                } else {
                    this.setState({
                        loading: false,
                    });
                }
            }).catch(error => {
                this.setState({
                    loading: false,
                });
            })
    }

    /**
     * Handle Component mouted and call backend to get the commands
     */
    componentDidMount() {
        this.setState({
            loading: true,
        });
        this.interval = setInterval(() => {
            const startDate = typeof this.state.startDate === 'string' ? this.state.startDate : this.state.startDate.format("YYYY-MM-DD");
            const endDate = typeof this.state.endDate === 'string' ? this.state.endDate : this.state.endDate.format("YYYY-MM-DD");
            this.filterCommands(
                this.state.tablePageSize,
                this.state.currentPage,
                startDate,
                endDate
            );
        }, TIME_FETCH_DATA);

    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    /**
     * Render the UI
     */
    render() {

        /**
         * Data Table columns
         */
        const columns = [
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Usuário</div>
                },
                align: 'center',
                dataIndex: 'username',
                width: 130,
                ...this.tableSearch.getColumnSearchProps('username', "Usuário"),
                sorter: (a, b) => {
                    return a.username.length - b.username.length
                },
                sortDirections: ['descend'],
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Placa</div>
                },
                align: 'center',
                dataIndex: 'plate',
                width: 130,
                sorter: (a, b) => a.plate.length - b.plate.length,
                sortDirections: ['descend']
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Comando Enviado</div>
                },
                align: 'center',
                dataIndex: 'cmdType',
                width: 150,
                ellipsis: {
                    showTitle: true,
                },
                render: (nameCmd) => (
                    <Tooltip>
                        {nameCmd}
                    </Tooltip>
                ),
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Data do Envio</div>
                },
                align: 'center',
                dataIndex: 'sentDate',
                width: 130,
                sorter: (a, b) => a.sentDate.length - b.sentDate.length,
                sortDirections: ['descend', 'ascend'],
                render: (text) => moment(text).format('HH:mm:ss DD/MM/YYYY'),
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Slave</div>
                },
                align: 'center',
                dataIndex: 'slave',
                width: 60,
                ...this.tableSearch.getColumnSearchProps('slave', "Slave"),
                sorter: (a, b) => {
                    if (a.slave === null || b.slave === null) {
                        return null
                    } else {
                        return a.slave.length - b.slave.length;
                    }
                },
                sortDirections: ['descend', 'ascend'],
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Resposta ao Comando</div>
                },
                align: 'center',
                dataIndex: 'responseCmd',
                width: 150,
                ...this.tableSearch.getColumnSearchProps('cmdType', "Resposta ao Comando"),
                sorter: (a, b) => a.cmdType.length - b.cmdType.length,
                sortDirections: ['descend'],
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Recepção do comando</div>
                },
                align: 'center',
                dataIndex: 'responseDate',
                width: 130,
                sorter: (a, b) => a.sentDate.length - b.sentDate.length,
                sortDirections: ['descend', 'ascend'],
                render: (text) => {
                    if (text == null) {
                        return "Sem data";
                    } else {
                        return moment(text).format('HH:mm:ss DD/MM/YYYY');
                    }

                },
            }

        ];

        /**
         * Pagination Options
         */
        const paginationConfig = {
            defaultPageSize: this.state.tablePageSize,
            total: this.state.totalRegisters,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            onChange: (page, pageSize) => {
                this.setState({
                    tablePageSize: pageSize,
                    currentPage: page
                });

                const startDate = typeof this.state.startDate === 'string' ? this.state.startDate : this.state.startDate.format("YYYY-MM-DD");
                const endDate = typeof this.state.endDate === 'string' ? this.state.endDate : this.state.endDate.format("YYYY-MM-DD");

                this.filterCommands(
                    pageSize, page, startDate, endDate
                );
            },
        }

        const paginationTable = this.state.totalRegisters === 0 ? false : paginationConfig;

        if (!this.state.loading) {
            this.getPlates()
        }
        return (
            <>
                <AppLayout>
                    <Card title="Comandos" style={{ height: '100%' }} bodyStyle={{ paddingLeft: 5, paddingRight: 5, paddingBottom: 5, paddingTop: 5 }}>
                        <Row style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                            <Col xs={24} sm={24} md={12} lg={12} xl={8} style={{ display: 'flex' }}>
                                <DatePicker
                                    format={{
                                        format: 'YYYY-MM-DD 00:00:00',
                                        type: 'mask',
                                    }}
                                    placeholder='Data Inicial'
                                    onChange={(date, dateString) => {
                                        this.setState({
                                            startDate: dateString,
                                        });
                                        this.filterCommands(
                                            this.state.tablePageSize,
                                            this.state.currentPage,
                                            dateString,
                                            this.state.endDate,
                                            this.state.searchText,
                                        );
                                    }}
                                    style={{ width: '50%' }}
                                />
                                <DatePicker
                                    format={{
                                        format: 'YYYY-MM-DD 23:59:59',
                                        type: 'mask',
                                    }}
                                    placeholder='Data Final'
                                    onChange={(date, dateString) => {
                                        this.setState({
                                            endDate: dateString,
                                        });
                                        this.filterCommands(
                                            this.state.tablePageSize,
                                            this.state.currentPage,
                                            this.state.startDate,
                                            dateString,
                                            this.state.searchText,
                                        );
                                    }}
                                    style={{ width: '50%', marginLeft: '5%' }}
                                />
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                <Select
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    filterSort={(optionA, optionB) =>
                                        optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                                    }
                                    onChange={e => {
                                        this.setState({
                                            searchText: e,
                                        });
                                        this.filterCommands(
                                            this.state.tablePageSize,
                                            this.state.currentPage,
                                            this.state.startDate,
                                            this.state.endDate,
                                            e
                                        );
                                    }}
                                    allowClear
                                    placeholder="Pesquisar por placa"
                                    options={this.state.plates ? this.state.plates : null}
                                    style={{ width: '60%' }}
                                />
                            </Col>
                            <Col span={4}>
                                <span className="d-flex justify-content-end">
                                    <Button
                                        className='successButton'
                                        type='primary'
                                        shape="round"
                                    >
                                        <CSVLink
                                            data={this.state.commandsData}
                                            separator={";"}
                                            filename={"commands.csv"}
                                        >
                                            Download CSV
                                        </CSVLink>
                                    </Button>
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <div style={{ marginTop: "30px" }}>
                                    <Table
                                        style={{ height: '100%' }}
                                        loading={!this.state.loading}
                                        columns={columns}
                                        size='small'
                                        dataSource={this.state.commandsData}
                                        pagination={paginationTable} rowClassName={(record, index) => index % 2 === 0 ? 'row-dark ' : 'row-light'}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Card>
                </AppLayout>
            </>
        );
    }
}

export default withRouter(MgmtCommands);